import { useEffect } from 'react';
import { Check, Bell } from 'lucide-react';
import Popup from '../common-components/pop-up/Popup';
import { INotification } from '../../services/notification.service';
import styles from './NotificationPopup.module.css';

interface NotificationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onMarkAsRead: (id: string) => void;
  notifications: INotification[];
  isLoading: boolean;
}

const NotificationPopup = ({
  isOpen,
  onClose,
  onMarkAsRead,
  notifications,
  isLoading,
}: NotificationPopupProps) => {
  useEffect(() => {
    if (isOpen) {
      // Popup açıldığında bildirimleri fetch etmek için parent'tan çağrılacak
    }
  }, [isOpen]);

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title="Bildirimler"
      description="Okunmamış bildirimlerinizi görüntüleyin"
      variant="info"
      icon={<Bell size={22} strokeWidth={2} />}
    >
      <div className={styles.notificationPopupContent}>
        {isLoading ? (
          <div className={styles.notificationEmpty}>Yükleniyor...</div>
        ) : notifications.length === 0 ? (
          <div className={styles.notificationEmpty}>Bildirim yok</div>
        ) : (
          <div className={styles.notificationList}>
            {notifications.map(notif => (
              <div key={notif.id} className={styles.notificationRow}>
                <div className={styles.notificationContent}>
                  <div className={styles.notificationTitle}>{notif.title}</div>
                  <div className={styles.notificationMessage}>{notif.message}</div>
                </div>
                <button
                  type="button"
                  className={styles.checkButton}
                  onClick={() => onMarkAsRead(notif.id)}
                  title="Okundu işaretle"
                >
                  <Check size={20} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Popup>
  );
};

export default NotificationPopup;
